/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import ViewOnboardingBranch from '../../../components/ViewOnboardingBranch';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { dataService } from '../../../services/data.services';
import CardHeader from '../../../components/CardHeader';

const ViewBranches = () => {
    const {id} = useParams();
    const navigate = useNavigate()
    const location = useLocation()
    const [branchRecodes, setBranchRecodes] = useState({})
    const [viewLoading,setViewLoading] = useState(true)

    /**
     * The function `getInstitutionUserData` is an asynchronous function that retrieves data from an
     * API endpoint and updates state variables accordingly, and handles any errors that occur.
     */
    const getInstitutionUserData = async() => {
        try {
            let res = await dataService.GetAPI(`branch/${id.split("*")[0]}`);
            setBranchRecodes(res.data.data)
            setViewLoading(false)
        } catch (error) {
            setViewLoading(false)
            // setToastErrorMessage(error.message)
            navigate("/404")
        } 
        
    }

    /* The `useEffect` hook is used to perform side effects in a functional component. In this case,
    the `useEffect` hook is used to call the `getInstitutionUserData` function when the `location`
    variable changes. */
    useEffect(() => {
        getInstitutionUserData()
    }, [location])  
 
    return (
        <CardHeader noPadding>        
            <ViewOnboardingBranch viewLoading={viewLoading} branchRecodes={branchRecodes} />
        </CardHeader>        );
}

export default ViewBranches;
